import { learningItemSlugs } from "utils/constants"
import { getPlatformURL } from "utils/helpers"

import MEdDegreeCard from "../MEdDegreeCard"
import SuraasaLogo from "./assets/Suraasa.svg"
import CertificateCardComponent from "./CertificateCardComponent"

const SuraasaCertificateCard = ({
  learningItemType,
  serialNumber,
  slug,
}: {
  learningItemType: string
  slug: string
  serialNumber?: string | null
}) => {
  const hasCertificate = !!serialNumber
  const DynamicComponent = hasCertificate ? "a" : "div"
  switch (slug) {
    case learningItemSlugs.pgctl:
      return (
        <DynamicComponent
          href={getPlatformURL("suraasa", `/verify/${serialNumber}`)}
          target="_blank"
          rel="noreferrer"
        >
          <CertificateCardComponent
            learningItemType={learningItemType}
            serialNumber={serialNumber}
            slug={slug}
            logo={SuraasaLogo}
          />
        </DynamicComponent>
      )
    case learningItemSlugs.med:
      return <MEdDegreeCard serialNumber={serialNumber} />
  }
}

export default SuraasaCertificateCard
